import React, { useState, useEffect } from "react";
import apiClient from "../api/apiClient";
import { data } from "react-router-dom";

const NuevoCliente = () => {
    const [formData, setFormData] = useState({
        Series: "",
        CardName: "",
        CardForeignName: "",
        FederalTaxID: "",
        CardType: "C", // Cliente por defecto
        GroupCode: "",
        //GroupName: "",
        Phone1: "",
        EmailAddress: "",
        U_tipoidentificacion: "",
        BPAddresses: [
            {
                AddressName: "",
                Street: "",
                ZipCode: "",
                AddressType: "bo_BillTo", // Dirección de facturación por defecto
            },
        ],
    });

    const [groups, setGroups] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [tipoIdentificaciones] = useState([
        { code: "11", description: "RUC" },
        { code: "12", description: "CEDULA" },
        { code: "13", description: "PASAPORTE" },
        { code: "14", description: "CEDULA EXTRANJERA" },
        { code: "15", description: "SIN NOMBRE" },
        { code: "16", description: "DIPLOMATICO" },
        { code: "17", description: "IDENTIFICACION TRIBUTARIA" },
        { code: "18", description: "CLIENTE DEL EXTERIOR" },
    ]);
    const [series] = useState([
        { code: "78", description: "Cliente Extranjero" },
        { code: "83", description: "Cliente Local" },
    ]);
    const [databases, setDatabases] = useState([]);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const databasesResponse = await apiClient.get("/databases");
                const groupsResponse = await apiClient.get("/groups");
                //const nextCodeResponse = await apiClient.get("/next-business-partner-code");

                //setFormData((prevData) => ({
                //    ...prevData,
                //    CardCode: nextCodeResponse.data.next_code,
                //}));
                setGroups(groupsResponse.data);
                setDatabases(databasesResponse.data.filter((db) => db.MigrarSN === "SI"));
            } catch (err) {
                setError("Error al cargar los datos iniciales. Intenta nuevamente.");
            }
        };
        fetchInitialData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        const updatedAddresses = [...formData.BPAddresses];
        updatedAddresses[0][name] = value;
        setFormData({ ...formData, BPAddresses: updatedAddresses });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const sapUser = JSON.parse(localStorage.getItem("sapUser"));
        if (!sapUser) {
            setError("Credenciales no disponibles. Por favor, inicie sesión nuevamente.");
            return;
        }

        const dataToSend = {
            data: formData,
            credentials: sapUser,
        };

        try {
            const res = await apiClient.post("/business-partners", dataToSend);
            // 207: se creó solo en algunas bases. Se deja el formulario cargado
            // para reintentar (las bases donde ya existe se omiten).
            if (res.status === 207) {
                setError(res.data?.message || "El cliente no se pudo crear en todas las bases.");
                setMessage("");
                return;
            }
            setMessage(res.data?.message || "Cliente creado exitosamente");
            setError("");

            // Reiniciar campos tras guardar
            setFormData({
                ...formData,
                Series:"",
                CardName: "",
                CardForeignName: "",
                FederalTaxID: "",
                Phone1: "",
                EmailAddress: "",
                U_tipoidentificacion: "",
                GroupName: "",
                BPAddresses: [
                    {
                        AddressName: "",
                        Street: "",
                        ZipCode: "",
                        AddressType: "bo_BillTo",
                    },
                ],
            });
        } catch (err) {
            if (err.response?.data?.message) {
                setError(err.response.data.message);
            } else if (err.response?.data?.error) {
                setError(err.response.data.error);
            } else {
                setError("Error inesperado. Por favor, inténtalo nuevamente.");
            }
            setMessage("");
        }
    };

    return (
        <div className="container mt-4">
            <h2>Crear Nuevo Cliente</h2>
            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            <div className="mt-3">
                <h5 style={{ fontSize: "1.0rem" }}>Bases de datos configuradas:</h5>
                <ul>
                    {databases.map((db, index) => (
                        <li key={index} style={{ fontSize: "0.7rem" }}>
                            <strong>{db.CompanyName}</strong>
                        </li>
                    ))}
                </ul>
            </div>

            <form onSubmit={handleSubmit}>
                {/* Fila 1 */}
                <div className="row">
                    <div className="col-md-3">
                        <label htmlFor="Series">Tipo de Cliente</label>
                        <select
                            className="form-control"
                            id="Series"
                            name="Series"
                            value={formData.Series}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione un tipo</option>
                            {series.map((tipo) => (
                                <option key={tipo.code} value={tipo.code}>
                                    {tipo.description}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="CardName">Nombre del Cliente</label>
                        <input
                            type="text"
                            className="form-control"
                            id="CardName"
                            name="CardName"
                            value={formData.CardName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="U_tipoidentificacion">Tipo de Identificación</label>
                        <select
                            className="form-control"
                            id="U_tipoidentificacion"
                            name="U_tipoidentificacion"
                            value={formData.U_tipoidentificacion}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione un tipo</option>
                            {tipoIdentificaciones.map((tipo) => (
                                <option key={tipo.code} value={tipo.code}>
                                    {tipo.description}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Fila 2 */}
                <div className="row mt-3">
                    <div className="col-md-3">
                        <label htmlFor="CardForeignName">Nombre de Fantasía</label>
                        <input
                            type="text"
                            className="form-control"
                            id="CardForeignName"
                            name="CardForeignName"
                            value={formData.CardForeignName}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="FederalTaxID">Documento Fiscal</label>
                        <input
                            type="text"
                            className="form-control"
                            id="FederalTaxID"
                            name="FederalTaxID"
                            value={formData.FederalTaxID}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="EmailAddress">Correo Electrónico</label>
                        <input
                            type="email"
                            className="form-control"
                            id="EmailAddress"
                            name="EmailAddress"
                            value={formData.EmailAddress}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                {/* Fila 3 */}
                <div className="row mt-3">
                    <div className="col-md-3">
                        <label htmlFor="Phone1">Teléfono</label>
                        <input
                            type="text"
                            className="form-control"
                            id="Phone1"
                            name="Phone1"
                            value={formData.Phone1}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="AddressName">Nombre de la Dirección</label>
                        <input
                            type="text"
                            className="form-control"
                            id="AddressName"
                            name="AddressName"
                            value={formData.BPAddresses[0].AddressName}
                            onChange={handleAddressChange}
                            required
                        />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="Street">Calle</label>
                        <input
                            type="text"
                            className="form-control"
                            id="Street"
                            name="Street"
                            value={formData.BPAddresses[0].Street}
                            onChange={handleAddressChange}
                            required
                        />
                    </div>
                </div>

                {/* Fila 4 */}
                <div className="row mt-3">
                    <div className="col-md-4">
                        <label htmlFor="GroupCode">Grupo</label>
                        <select
                            className="form-control"
                            id="GroupCode"
                            name="GroupCode"
                            value={formData.GroupCode}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione</option>
                            {groups.map((group) => (
                                <option key={group.Code} value={group.Code}>
                                    {group.Name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Botón de envío */}
                <div className="row mt-3">
                    <div className="col-md-4">
                        <button type="submit" className="btn btn-primary mt-2">
                            Crear Cliente
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default NuevoCliente;
